<div class="form-group row" *ngIf="control.visible" [formGroup]="formGroup">
  <div class="col-md-12">
    <hb-df-control-label [control]="control" (onOverrideValue)="overrideValue()"></hb-df-control-label>
  </div>
  <div class="col-md-12">
    <p-dropdown
      class="form-control hb-dropdown hb-filter-dropdown hb-dropdown-filter"
      [id]="control.key"
      [placeholder]="control.placeholder || control.label"
      [options]="formatOptions(control.options)"
      [formControlName]="control.key"
      [filter]="true"
      [virtualScroll]="false"
      [virtualScrollItemSize]="30"
      [attr.disable]="control.disabled"
      [showClear]="true"
      appendTo="body"
      [ngClass]="{ 'is-invalid': control.enableValidation && control.form?.submitted && control.isInvalid }"
    ></p-dropdown>
    <div
      *ngIf="control.enableValidation && control.form?.submitted && control.isInvalid"
      class="primeng-invalid-feedback div-word-wrap validation-error-text"
    >
      <div *ngIf="control.formControl.errors.required" [pTooltip]="control.label + ' is required.'">{{ control.label }} is required.</div>
    </div>
  </div>
</div>
